import axios from "axios";

export const state = {
    sales: [],
};

export const getters = {
    sales: (state) => state.sales,
};

export const mutations = {
    setSales(state, newValue) {
        state.sales = newValue;
    },
};

export const actions = {
    fetchSales({ commit }, {page = 1, user = null}) {
        commit("setSales", []);
        const userParam = user ? `/${user}` : "";
        axios.get(`/sales/${page}${userParam}`).then((res) => {
            commit("setSales", res.data.sales);
        });
    },

    getSale({ commit }, trans_id) {
        commit("setSales", []);
        axios.get(`/get-transaction/${trans_id}`).then((res) => {
            commit("setSales", res.data.sales);
        })
    }
};
